import React from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import RichText from '../../richText';
import CategoryForm from './categoryForm';

const CategoryGroupItem = ({ categoryItem, locale, history }) => {
  const {
    fields: { title, forms, description }
  } = categoryItem;

  return (
    <div className="category-card">
      <div className="category-card__inner">
        <div className="category-card__header">
          <Typography heading="h3" variant={{ size: 'h3' }} block><span style={{fontWeight: 500}}>{title}</span></Typography>
          <Typography variant={{ size: 'large' }}>
            <RichText data={description} />
          </Typography>
        </div>
        <div className="category-card__forms">
          {forms.map(formData => (
            <CategoryForm
              formData={formData}
              locale={locale}
              history={history}
              categoryItemData={categoryItem}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

CategoryGroupItem.propTypes = {
  categoryItem: PropTypes.shape({
    metadata: PropTypes.shape({}),
    sys: PropTypes.shape({}),
    fields: PropTypes.shape({
      availableFor: PropTypes.arrayOf(PropTypes.string),
      description: PropTypes.shape({
        data: PropTypes.shape({}),
        content: PropTypes.arrayOf(PropTypes.shape({})),
        nodeType: PropTypes.string
      }),
      forms: PropTypes.arrayOf(PropTypes.shape({})),
      image: PropTypes.shape({
        fields: PropTypes.shape({
          file: PropTypes.shape({
            url: PropTypes.string
          })
        })
      }),
      title: PropTypes.string,
      name: PropTypes.string,
      platform: PropTypes.string
    })
  }).isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default CategoryGroupItem;
